/** @format */
const KLIPPA_BASE_URL = "https://custom-ocr.klippa.com/api/v1";
const KLIPPA_AUTH_KEY = process.env.REACT_APP_KLIPPA_AUTH_KEY;
const WEBHOOK_AUTH_KEY = process.env.REACT_APP_WEBHOOK_AUTH_KEY;
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

/**
 * Appelle l’API Klippa pour récupérer dynamiquement le sessionToken.
 */
export async function getSessionTokenKlippa() {
  const url = `${KLIPPA_BASE_URL}/IdentityVerification/Session`;

  const body = {
    AllowPictureFallback: false,
    CheckIDForSignature: true,
    CheckMrzFieldChecksums: true,
    CheckVizMrzValidations: true,
    CompareSelfiesWithID: true,
    FaceComparisonThreshold: 0.82,
    FieldValidations: {},
    FieldsToMask: ["DocumentType"],
    MatchDocumentSides: true,
    RequiredFields: ["DocumentType"],
    RequiredIDBackPicturesCount: 1,
    RequiredIDFrontPicturesCount: 1,
    RequiredLivenessCount: 1,
    RequiredNFCScanCount: 0,
    RequiredSelfiesCount: 1,
    RequiredSignatures: 1,
    RetryLimit: 0,
    SkipPassportBackPicture: true,
    ValidTime: 4800,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Auth-Key": KLIPPA_AUTH_KEY,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP ${response.status} : ${errorText}`);
    }

    const data = await response.json();
    console.log("Réponse Klippa :", data);

    const sessionToken = data.data.Session.Token;

    if (!sessionToken) {
      throw new Error("Aucun sessionToken trouvé dans la réponse Klippa.");
    }

    console.log("Session token trouvé :", sessionToken);

    return sessionToken;
  } catch (error) {
    console.error("Erreur lors de la récupération du token Klippa :", error);
    throw error;
  }
}

/**
 * Appelle l’API Klippa pour récupérer des informations sur une session existante.
 */
export async function getKlippaSession(sessionId) {
  if (!sessionId)
    throw new Error("sessionId est requis pour getKlippaSession()");

  const url = `${KLIPPA_BASE_URL}/IdentityVerification/Session/${sessionId}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Auth-Key": KLIPPA_AUTH_KEY,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP ${response.status} : ${errorText}`);
    }

    const data = await response.json();

    console.log("Session Klippa récupérée :", data);
    return data?.data || data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération de la session Klippa :",
      error
    );
    throw error;
  }
}

/**
 * Appelle Api pour recuperer les fichiers extraits Klippa
 */
export async function getKlippaFile(sessionId, fileRef) {
  if (!sessionId || !fileRef)
    throw new Error("⚠️ sessionId et fileRef sont requis pour getKlippaFile()");

  const url = `${KLIPPA_BASE_URL}/IdentityVerification/Session/${sessionId}/File/${fileRef}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-Auth-Key": KLIPPA_AUTH_KEY,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP ${response.status} : ${errorText}`);
    }

    // un blob est un fichier binaire (image)
    const blob = await response.blob();

    // Si besoin : créer une URL temporaire pour affichage dans <img>
    const fileUrl = URL.createObjectURL(blob);

    console.log(`Fichier Klippa [${fileRef}] récupéré :`, fileUrl);
    return { blob, fileUrl };
  } catch (error) {
    console.error("Erreur lors du téléchargement du fichier Klippa :", error);
    throw error;
  }
}

/** 
 * Téléchargement du fichier depuis le back-end avec sessionID et documentId.
 */
export async function webhookKlippa(sessionId, documentId) {
  if (!sessionId) {
    throw new Error("sessionId est requis pour webhookKlippa()");
  }

  const url = `${REACT_APP_API_URL}/webhooks/klippa/id/`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "x-api-key": WEBHOOK_AUTH_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sessionid: sessionId, docid: documentId }),
    });

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(`webhookKlippa HTTP ${response.status} : ${errorText}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Erreur lors de l'appel au webhook back :", error);

    throw error;
  }
}
